<template>
    <svg width="16px" height="9px" viewBox="0 0 16 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="operegrino" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Home/desktop-Copy-4" transform="translate(-1374.000000, -45.000000)" fill="#FFFFFF" fill-rule="nonzero">
                <g id="Group-17" transform="translate(418.529907, 22.113445)">
                    <g id="Group" transform="translate(929.000000, 10.500000)">
                        <path d="M41.5519652,12.5940018 C41.2879564,12.3174213 40.8598267,12.3173741 40.5957728,12.5940491 L34.3126606,19.1764963 L28.0292328,12.5940018 C27.765224,12.3174213 27.3370943,12.3173741 27.0730404,12.5940491 C26.8089865,12.8706768 26.8089865,13.3191463 27.0730404,13.5957741 L33.8345869,20.6791074 C33.9613851,20.8119435 34.1333492,20.8865546 34.3126606,20.8865546 C34.491972,20.8865546 34.6639812,20.8118963 34.7907342,20.6790602 L41.5519201,13.5957268 C41.8160191,13.3191463 41.8160191,12.8706296 41.5519652,12.5940018 Z" id="arrow"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {

}
</script>
